import { FC, ReactNode } from 'react';
import Link from 'next/link';
import clsx from 'clsx';

import styles from './CategoryCard.module.scss';

interface CategoryCardProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  path: string;
  className?: string;
  iconMobileNone?: boolean;
  closePopover?: () => void;
}

const CategoryCard: FC<CategoryCardProps> = ({
  icon,
  subtitle,
  title,
  path,
  className = '',
  closePopover,
  iconMobileNone,
}) => {
  const categoryCardStyles: string = clsx({
    [styles.categoryCard]: true,
    [className]: className,
  });

  return (
    <div className={categoryCardStyles} onClick={closePopover}>
      <Link className={styles.link} href={path}></Link>
      {!iconMobileNone && <i className={styles.icon}>{icon}</i>}
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  );
};

export default CategoryCard;
